import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/account",
    name: "Account",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ "../views/Account.vue"),
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("../views/Users.vue"),
  },
  {
    path: "/CustomerMessages",
    name: "CustomerMessages",
    component: () => import("../views/CustomerMessages.vue"),
  },
  {
    path: "/blog/id/:id",
    name: "BlogId",
    component: () => import("../views/BlogSingle.vue"),
  },
  {
    path: "/blog/page/:page",
    name: "BlogPage",
    component: () => import("../views/Blog.vue"),
  },
  {
    path: "/shop/page/:page",
    name: "ShopPage",
    component: () => import("../views/Shop.vue"),
  },
  {
    path: "/shop/id/:id",
    name: "ShopId",
    component: () => import("../views/ShopSingle.vue"),
  },
  {
    path: "/social",
    name: "Social",
    component: () => import("../views/Social.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
